<template>
  <div class="search">
    <input
      type="text"
      placeholder="Buscar Definición..."
      name="search"
      v-model="readingExperience.word"
    />
    <button type="submit" @click="search">
      <i class="fa fa-search"></i>
    </button>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "br-dictionary-search",
  computed: {
    ...mapState(["readingExperience", "dictionaryApi"]),
  },
  data() {
    return {
      word: "",
    };
  },
  methods: {
    search() {
      let re = this.readingExperience;
      re.dictionary_data = [];

      if (!re.word) {
        alert("¿Que palabra deseas buscar?");
        return;
      }

      this.axios.get(this.dictionaryApi + `${re.word}`).then(response => {
        for (let item of response.data) {
          let word = { word: item.word };
          for (let name in item.meaning) {
            if (item.meaning.hasOwnProperty(name)) {
              word.meaning = name;
              word.definitions = item.meaning[name];
            }
          }
          re.dictionary_data.push(word);
        }
      });
    },
  },
};
</script>

<style lang="css">
div.search button {
  float: left;
  width: 20%;
  padding: 10px;
  background: #f6af10;
  color: white;
  font-size: 17px;
  border: 1px solid #4e4c5629;
  border-left: none;
  cursor: pointer;
  border-radius: 0vh 3vh 3vh 0vh;
}
div.search input[type="text"] {
  padding: 10px;
  font-size: 17px;
  border: 1px solid #4e4c5629;
  float: left;
  width: 80%;
  background: #4e4c5629;
  border-radius: 3vh 0vh 0vh 3vh;
}
</style>
